<div class="max-w-comfort">
  <p-card>
    <div class="mx-6 my-4">
      <app-patient-info-input title='Pre-Myopic' [name]="patientName"
        [ageAtVisit]="calculationResults.serCalcResponse.ethnicities[0].decimalAge" [dateOfLastVisit]="calculationResults.serCalcResponse.ethnicities[0].dateAtLastVisit"></app-patient-info-input>

      @if (reportType === ReportType.ECP && calculationResults.ageWarning) {
      <div class="mb-4">⚠️ {{ 'AGE_WARNING' | translate }}</div>
      }
      <app-premyopia-risk-score [premyopeTotalRiskScore]="calculationResults!.premyopeRiskResults!.totalScore"
        [personalization]="undefined"
        [premyopeTotalRiskScoreCatagory]="calculationResults!.premyopeRiskResults!.premyopeRiskScoreCategory"
        [ageCatagory]="calculationResults!.premyopeRiskResults!.ageCategory"
        [serRiskScore]="calculationResults!.premyopeRiskResults!.serRiskScore"
        [axialRiskScore]="calculationResults!.premyopeRiskResults!.axialLengthScore"
        [inheritabilityRiskScore]="calculationResults!.premyopeRiskResults!.inheritabilityRiskScore">
      </app-premyopia-risk-score>
      <div class="mb-6">
        <app-parent-paragraph *ngIf="reportType === ReportType.Parent" [retestMonths]="retestPeriodsMonths"
          [parentParagraphType]="ParentParagraphType.WHAT_IS_MYOPIA_MATTER"></app-parent-paragraph>
      </div>

      <app-premyopia-eim-retest *ngIf="reportType === ReportType.ECP"
        [premyopeRiskScoreCatagory]="calculationResults!.premyopeRiskResults!.premyopeRiskScoreCategory"
        [personalization]="undefined" [retestMonths]="retestPeriodsMonths"></app-premyopia-eim-retest>

      <app-population-comparison class="mt-6" [reportType]="reportType"
        [serCalcResponse]="calculationResults.serCalcResponse"
        [axialCalcResponse]="calculationResults.axialCalcResponse"
        [treatmentCalcResponse]="calculationResults.treatmentCalcResponse" [ethnicity]="currentEthnicity"
        (ethnicityChanged)="onEthnicityChange($event)"></app-population-comparison>
      @if ((calculationResults.standardProgressionReponse.leftEyeResults ||
      calculationResults.standardProgressionReponse.rightEyeResults)
      && reportType === ReportType.ECP) {
      <app-standard-progression [ethnicity]="currentEthnicity" (ethnicityChanged)="onEthnicityChange($event)"
        [mostMyopicEyeSide]="calculationResults.serCalcResponse.mostMyopicEye ?? calculationResults.axialCalcResponse.mostMyopicEye"
        [ageAtProgression]="calculationResults.standardProgressionReponse.ageAtProgression"
        [leftEyeProgressionStat]="calculationResults.standardProgressionReponse.leftEyeResults"
        [rightEyeProgressionStat]="calculationResults.standardProgressionReponse.rightEyeResults"></app-standard-progression>
      }
      <div class="mb-6">
        <app-parent-paragraph *ngIf="reportType === ReportType.Parent" [retestMonths]="retestPeriodsMonths"
          [parentParagraphType]="ParentParagraphType.SLOWDOWN_MYOPIA_PREMYOPE"></app-parent-paragraph>
        <app-parent-paragraph *ngIf="reportType === ReportType.Parent" [retestMonths]="retestPeriodsMonths"
          [parentParagraphType]="ParentParagraphType.WHAT_NEXT_PREMYOPE"
          [premyopeRiskScoreCatagory]="calculationResults!.premyopeRiskResults!.premyopeRiskScoreCategory"></app-parent-paragraph>
      </div>

      <app-credits class="w-full"></app-credits>
    </div>
  </p-card>
</div>
<div class="max-w-comfort"></div>